const getBackendUrl = () => {
  // if (process.env.NODE_ENV === 'production') {
  //   return process.env.REACT_APP_API_URL;
  // }
  
  // let port = 4000 ;
  
  // try {
  //   // Try to read from localStorage first (if server wrote it there)
  //   const savedPort = localStorage.getItem('serverPort');
  //   if (savedPort) {
  //     port = savedPort;
  //   } else {
  //     // Fallback to default port 5000
  //     port = 4000;
  //     console.log('Using default port 5000');
  //   }
  // } catch (err) {
  //   console.log('Falling back to default port 5000');
  // }
  
  // https://jrt-crm.onrender.com -http://localhost:${port}
  return `https://system.jrtroofing.com`;
};

export const config = {
  mapboxAccessToken: 'pk.eyJ1IjoianJ0cm9vZmluZyIsImEiOiJjbTc0ejEyemIwZnJvMmtvbDRnN2sxZXgyIn0.Aa-o43jQ6h_LdmsBssHn4Q',
  apiUrl: getBackendUrl()
}; 